import React, { forwardRef } from 'react';
import classnames from 'classnames';

export default forwardRef(({ width, height, className, children}, ref) => {
  const wrapperClasses = classnames('chart', className);

  return (
    <svg
      ref={ref}
      className={wrapperClasses}
      width={width}
      height={height}
      viewBox={`0,0,${width},${height}`}
    >
      {children}
    </svg>
  );
});
